import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

// Global Utils
import minutesToDuration from 'utils/minutes-to-duration';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    sumTotalMinutes?: number;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetTotalTime extends React.PureComponent<Props> {
    render(): string | null {
        const { sumTotalMinutes } = this.props;
        if (!sumTotalMinutes) return null;


        return minutesToDuration(sumTotalMinutes);
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    sumTotalMinutes: makeSelectTimesheetValue('sumTotalMinutes')
});

export default connect(mapStateToProps)(TimesheetTotalTime);
